module.exports = __webpack_public_path__ + "img/Hawaiian_Meal_Pork.10368044.jpg";